import { render } from "./headerSlot.vue?vue&type=template&id=1665fadb"
import script from "./headerSlot.vue?vue&type=script&lang=js"
export * from "./headerSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__